"use strict";
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransferDetailsEntry_Highlight = exports.protobufPackage = void 0;
exports.protobufPackage = "transfer_details";
var TransferDetailsEntry_Highlight;
(function (TransferDetailsEntry_Highlight) {
    /** NONE - standard */
    TransferDetailsEntry_Highlight[TransferDetailsEntry_Highlight["NONE"] = 0] = "NONE";
    /** GREEN - e.g. completed transfer */
    TransferDetailsEntry_Highlight[TransferDetailsEntry_Highlight["GREEN"] = 1] = "GREEN";
    /** BLUE - e.g. likelihood: low */
    TransferDetailsEntry_Highlight[TransferDetailsEntry_Highlight["BLUE"] = 2] = "BLUE";
    /** ORANGE - e.g. likelihood: medium */
    TransferDetailsEntry_Highlight[TransferDetailsEntry_Highlight["ORANGE"] = 3] = "ORANGE";
    /** RED - e.g. likelihood: high */
    TransferDetailsEntry_Highlight[TransferDetailsEntry_Highlight["RED"] = 4] = "RED";
    TransferDetailsEntry_Highlight[TransferDetailsEntry_Highlight["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(TransferDetailsEntry_Highlight || (exports.TransferDetailsEntry_Highlight = TransferDetailsEntry_Highlight = {}));
//# sourceMappingURL=transfer_details.js.map